export default "__VITE_ASSET__Ba8R4Evj__"